import { render, staticRenderFns } from "./ModulePresentLevel1.vue?vue&type=template&id=09949985&scoped=true&"
import script from "./ModulePresentLevel1.vue?vue&type=script&lang=js&"
export * from "./ModulePresentLevel1.vue?vue&type=script&lang=js&"
import style0 from "./ModulePresentLevel1.vue?vue&type=style&index=0&id=09949985&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09949985",
  null
  
)

export default component.exports